<template>
  <div class="MedicenCata">
    <!-- main -->
    <div class="main">
      <!-- right -->
      <div class="main-right">
        <!-- tit -->
        <div class="main-icon">
          <div class="main-icon-a">
            <i :class="iconComes"
               style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
            <span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
          </div>
          <!-- btn1 -->
          <div class="main-icon-b">
            <span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
            <el-dropdown @command="handleCommand" trigger="click">
    <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
      {{ DropDownedName }}<i class="el-icon-down"></i>
    </span>
              <el-dropdown-menu slot="dropdown" class="status-dropdown">
                <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 按钮栏 -->
          <div class="main-icon-c">
            <div style="display: inline-block; margin-left: 10px;">
              <span class="select-label">科室:</span>
              <el-select
                  v-model="department"
                  placeholder="科室查询"
                  clearable
                  filterable
                  size="mini"
                  @change="loadData"
                  class="custom-select">
                <el-option
                    v-for="item in findAttribute"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                </el-option>
              </el-select>

              <div style="display: inline-block; margin-left: 20px;">
                <span class="select-label">医生:</span>
                <el-select
                    v-model="doctor"
                    placeholder="医生查询"
                    clearable
                    filterable
                    size="mini"
                    @change="loadData"
                    class="custom-select">
                  <el-option
                      v-for="item in staff"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <!-- 按钮栏 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
                       v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                       @click="handClick(i)">{{ v.title }}
            </el-button>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handledbRow">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
                             :prop="col.prop" :label="col.name" align="center"
                             :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width='158'
                             v-if="$store.getters.hasPermission('system:drgstable:edit')">
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
                  <el-button :type="scope.row.state === 1 ? 'danger' : 'success'"
                             @click="handleStartOrDisabled(scope.row)" size="mini">
                    {{ scope.row.state === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
            class="fixed-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[8, 16, 24]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background>
        </el-pagination>
      </div>
    </div>

    <!-- 新增坐诊表单 -->
    <el-dialog title="新增坐诊" :visible.sync="addDialogVisible" width="50%" :before-close="handleClose"
               :close-on-click-modal="false" class="compact-form">
      <el-form :model="addForm" label-width="100px" size="mini" :rules="formRules" ref="addFormRef">
        <!-- 第一行：科室、医生、状态 -->
        <el-row :gutter="20">
          <!-- 科室 -->
          <el-col :span="8">
            <el-form-item prop="deptId" label="科室:">
              <el-select v-model="addForm.deptId" filterable placeholder="请选择科室" @change="handleDeptChange" style="width: 100%">
                <el-option v-for="item in findAttribute" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 医生 -->
          <el-col :span="8">
            <el-form-item prop="doctorId" label="医生姓名:">
              <el-select v-model="addForm.doctorId" filterable placeholder="请选择医生" :disabled="!addForm.deptId" style="width: 100%">
                <el-option v-for="item in active" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 状态 -->
          <el-col :span="7">
            <el-form-item prop="state" label="状态:">
              <el-select v-model="addForm.state" placeholder="请选择状态" style="width: 100%">
                <el-option v-for="item in state" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行：复选框 -->
        <!-- 第二行：复选框 -->
        <el-row :gutter="20" class="checkbox-row">
          <!-- 无需排班 -->
          <el-col :span="4">
            <el-form-item label="无需排班:">
              <el-checkbox
                  v-model="addForm.schedulingB"
                  :true-label="1"
                  :false-label="0"
                  @change="handleSchedulingBChange">
              </el-checkbox>
            </el-form-item>
          </el-col>

          <!-- 自定义排班 -->
<!--          <el-col :span="4">
            <el-form-item label="自定义排班:">
              <el-checkbox
                  v-model="addForm.schedulingC"
                  :true-label="1"
                  :false-label="0"
                  @change="handleSchedulingCChange">
              </el-checkbox>
            </el-form-item>
          </el-col>-->
        </el-row>

        <!-- 时间选择器部分 -->
        <div v-if="addForm.schedulingC === 1">
          <el-form-item label="时效：">
            <el-time-picker
                :value="[addForm.startTime, addForm.endTime]"
                @input="val => handleTimeChange(val, 'startTime', 'endTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="上午时段:">
            <el-time-picker
                :value="[addForm.smorningTime, addForm.emorningTime]"
                @input="val => handleTimeChange(val, 'smorningTime', 'emorningTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="下午时段:">
            <el-time-picker
                :value="[addForm.safternoonTime, addForm.eafternoonTime]"
                @input="val => handleTimeChange(val, 'safternoonTime', 'eafternoonTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="晚班时段:">
            <el-time-picker
                :value="[addForm.snightTime, addForm.enightTime]"
                @input="val => handleTimeChange(val, 'snightTime', 'enightTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>
        </div>

        <!-- 表格部分 -->
        <div class="table-header">
          <span>挂号类别:</span>
          <el-button-group class="transparent-btn-group">
            <el-button icon="el-icon-plus" size="mini" class="transparent-btn"
                       @click="handleCategoryAdd" :disabled="tableData2.length >= 1"></el-button>
            <el-button icon="el-icon-edit" size="mini" class="transparent-btn"
                       :disabled="!selectedRow" @click="handleCategoryEdit"></el-button>
            <el-button icon="el-icon-circle-close" size="mini" class="transparent-btn"
                       :disabled="!selectedRow" @click="handlePriceDelete"></el-button>
          </el-button-group>
        </div>

        <el-table :data="tableData2" border @row-click="handleRowClick" highlight-current-row ref="myTable">
          <el-table-column prop="rgstTypeId" label="挂号类别" :formatter="(row) => formatColumn(row, 'rgstTypeId')" align="center"></el-table-column>
          <el-table-column prop="mainType" label="主要类别" :formatter="(row) => row.mainType === 1 ? '是' : '否'" align="center"></el-table-column>
          <el-table-column prop="odcost" label="合计金额" align="center"></el-table-column>
          <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="addCategoryData">添加</el-button>
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 修改坐诊表单 -->
    <el-dialog title="编辑坐诊" :visible.sync="editDialogVisible" width="50%" :before-close="handleClose"
               :close-on-click-modal="false" class="compact-form">
      <el-form :model="editForm" label-width="100px" size="mini" :rules="formRules" ref="editFormRef"
               :disabled="isLookData">
        <!-- 第一行：科室、医生、状态 -->
        <el-row :gutter="20">
          <!-- 科室 -->
          <el-col :span="8">
            <el-form-item prop="deptId" label="科室:">
              <el-select v-model="editForm.deptId" filterable placeholder="请选择科室"  style="width: 100%">
                <el-option v-for="item in findAttribute" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 医生 -->
          <el-col :span="8">
            <el-form-item prop="doctorId" label="医生姓名:">
              <el-select v-model="editForm.doctorId" filterable placeholder="请选择医生"  style="width: 100%">
                <el-option v-for="item in active" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 状态 -->
          <el-col :span="7">
            <el-form-item prop="state" label="状态:">
              <el-select v-model="editForm.state" placeholder="请选择状态" style="width: 100%">
                <el-option v-for="item in state" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行：复选框 -->
        <!-- 第二行：复选框 -->
        <el-row :gutter="20" class="checkbox-row">
          <!-- 无需排班 -->
          <el-col :span="4">
            <el-form-item label="无需排班:">
              <el-checkbox
                  v-model="editForm.schedulingB"
                  :true-label="1"
                  :false-label="0"
                  @change="handleEditSchedulingBChange">
              </el-checkbox>
            </el-form-item>
          </el-col>

          <!-- 自定义排班 -->
<!--          <el-col :span="4">
            <el-form-item label="自定义排班:">
              <el-checkbox
                  v-model="editForm.schedulingC"
                  :true-label="1"
                  :false-label="0"
                  @change="handleEditSchedulingCChange">
              </el-checkbox>
            </el-form-item>
          </el-col>-->
        </el-row>

        <!-- 时间选择器部分 -->
        <div v-if="editForm.schedulingC === 1">
          <el-form-item label="时效：">
            <el-time-picker
                :value="[editForm.startTime, editForm.endTime]"
                @input="val => handleTimeChange2(val, 'startTime', 'endTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="上午时段:">
            <el-time-picker
                :value="[editForm.smorningTime, editForm.emorningTime]"
                @input="val => handleTimeChange2(val, 'smorningTime', 'emorningTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="下午时段:">
            <el-time-picker
                :value="[editForm.safternoonTime, editForm.eafternoonTime]"
                @input="val => handleTimeChange2(val, 'safternoonTime', 'eafternoonTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="晚班时段:">
            <el-time-picker
                :value="[editForm.snightTime, editForm.enightTime]"
                @input="val => handleTimeChange2(val, 'snightTime', 'enightTime')"
                is-range
                range-separator="-"
                format="HH:mm"
                value-format="HH:mm"
                size="mini"
                style="width: 100%">
            </el-time-picker>
          </el-form-item>
        </div>

        <!-- 表格部分 -->
        <div class="table-header">
          <span>挂号类别:</span>
          <el-button-group class="transparent-btn-group">
            <el-button icon="el-icon-plus" size="mini" class="transparent-btn"
                       @click="handleCategoryAdd" :disabled="tableData2.length >= 1 || isLookData"></el-button>
            <el-button icon="el-icon-edit" size="mini" class="transparent-btn"
                       :disabled="!selectedRow || isLookData" @click="handleCategoryEdit"></el-button>
            <el-button icon="el-icon-circle-close" size="mini" class="transparent-btn"
                       :disabled="!selectedRow || isLookData" @click="handlePriceDelete"></el-button>
          </el-button-group>
        </div>

        <el-table :data="tableData2" border @row-click="handleRowClick" highlight-current-row ref="myTable">
          <el-table-column prop="rgstTypeId" label="挂号类别" :formatter="(row) => formatColumn(row, 'rgstTypeId')" align="center"></el-table-column>
          <el-table-column prop="mainType" label="主要类别" :formatter="(row) => row.mainType === 1 ? '是' : '否'" align="center"></el-table-column>
          <el-table-column prop="odcost" label="合计金额" align="center"></el-table-column>
          <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitForm" :disabled="isLookData">修改</el-button>
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 挂号类别新增对话框 -->
    <el-dialog title="挂号类别-新增" :close-on-click-modal="false" :visible.sync="addCategoryDialogVisible" width="35%"
               :before-close="handleAddCategoryClose">
      <div style="display: flex; justify-content: center;">
        <el-form :model="addCategoryForm" size="mini">
          <el-form-item label="挂号类别:" prop="rgstTypeId" label-width="100px">
            <el-select filterable :filter-method="handleSimpleSearch" v-model="addCategoryForm.rgstTypeId"
                       placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in categoryOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="主要类别:" prop="mainType" label-width="100px">
            <el-select v-model="addCategoryForm.mainType" placeholder="请选择" style="width: 100%;">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleAddCategoryClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleAddPriceData">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 挂号类别修改对话框 -->
    <el-dialog :close-on-click-modal="false" title="挂号类别-修改" :visible.sync="editCategoryDialogVisible1" width="20%"
               :before-close="handleEditCategoryClose">
      <div style="display: flex; justify-content: center;">
        <el-form :model="editCategoryForm" size="mini">
          <el-form-item label="挂号类别:" prop="rgstTypeId" label-width="100px">
            <el-select filterable :filter-method="handleSimpleSearch" v-model="editCategoryForm.rgstTypeId"
                       placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in categoryOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="主要类别:" prop="mainType" label-width="100px">
            <el-select v-model="editCategoryForm.mainType" placeholder="请选择" style="width: 100%;">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleEditCategoryClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleEditCategoryData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  addClinicSchedule,
  editClinicSchedule,
  editState,
  getActiveList,
  getCategoryById,
  getClinicScheduleData,
} from "@/api/clinicSchedule/clinicSchedule";
import { withLoading } from "@/untils/loading";

// 工厂函数：生成空的新增表单
const getEmptyAddForm = () => ({
  deptId: null,
  doctorId: null,
  eafternoonTime: '18:00',
  emorningTime: '12:00',
  endTime: '23:59',
  rgstTypes: [],
  state: 1,
  safternoonTime: '13:00',
  schedulingB: 1,          // 默认选中“无需排班”
  schedulingC: 0,          // 默认不选中“自定义排班”
  smorningTime: '7:30',
  snightTime: '19:00',
  enightTime: '23:59',
  startTime: '00:00',
});

// 工厂函数：生成空的编辑表单
const getEmptyEditForm = () => ({
  id: null,
  deptId: null,
  doctorId: null,
  eafternoonTime: '',
  state: null,
  emorningTime: '',
  endTime: '',
  rgstTypes: [],
  safternoonTime: '',
  schedulingB: 1,
  schedulingC: 0,
  smorningTime: '',
  snightTime: '',
  enightTime: '',
  startTime: '',
});

// 工厂函数：生成空的挂号类别新增表单
const getEmptyAddCategoryForm = () => ({
  rgstTypeId: null,
  mainType: 1,
  odcost: null
});

// 工厂函数：生成空的挂号类别编辑表单
const getEmptyEditCategoryForm = () => ({
  rgstTypeId: null,
  mainType: null,
  odcost: null
});

// 时间校验工具函数（保持原有校验规则）
const validateScheduleTimes = (form) => {
  if (form.smorningTime < '07:30') return '上午开始时间不能早于7:30';
  if (form.emorningTime > '12:00') return '上午结束时间不能晚于12:00';
  if (form.safternoonTime < '13:00') return '下午开始时间不能早于13:00';
  if (form.eafternoonTime > '18:00') return '下午结束时间不能晚于18:00';
  if (form.snightTime < '19:00') return '晚上开始时间不能早于19:00';
  if (form.enightTime > '23:59') return '晚上结束时间不能晚于23:59';
  return null;
};

export default {
  data() {
    return {
      department: null,
      doctor: null,
      CatalogueName: '坐诊管理',
      DropDownedName: '全部',
      iconComes: 'el-icon-cflx',
      loading: false,
      addDialogVisible: false,
      editDialogVisible: false,
      addCategoryDialogVisible: false,
      editCategoryDialogVisible1: false,
      selectedRow: null,
      isLookData: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      numericValue: null, // 状态筛选值（原代码缺失，补充）
      categoryOptions: [],
      addCategoryForm: getEmptyAddCategoryForm(),
      editCategoryForm: getEmptyEditCategoryForm(),
      addForm: getEmptyAddForm(),
      editForm: getEmptyEditForm(),
      formRules: {
        deptId: [{ required: true, message: '请选择科室', trigger: 'blur' }],
        doctorId: [{ required: true, message: '请选择医生', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      userInfo: [],
      findAttribute: [],
      active: [],
      staff: [],
      state: [{ id: 1, label: '有效' }, { id: 0, label: '禁用' }],
      headerBtn: [
        { add: "add", title: "新增", type: "warning", auth: 'system:drgstable:add' },
      ],
      tableRows: [
        { name: "科室名称", prop: "deptName", type: "" },
        { name: "医生名称", prop: "doctorName", type: "" },
        { name: "挂号类别", prop: "registertypeName", type: "" },
        { name: "开始时间", prop: "startTime", type: "" },
        { name: "结束时间", prop: "endTime", type: "" },
        { name: "上午开始时间", prop: "smorningTime", type: "" },
        { name: "上午结束时间", prop: "emorningTime", type: "" },
        { name: "下午开始时间", prop: "safternoonTime", type: "" },
        { name: "下午结束时间", prop: "eafternoonTime", type: "" },
        { name: "晚上开始时间", prop: "snightTime", type: "" },
        { name: "晚上结束时间", prop: "enightTime", type: "" },
      ],
      tableData: [],
      tableData2: [],
    };
  },

  async mounted() {
    await this.loadData();
    this.categoryOptions = this.$store.getters['preload/getCategoryOptions'] || [];
    this.findAttribute = this.$store.getters['preload/getDeptListOptions'] || [];
    this.staff = this.$store.getters['preload/getStaffListOptions'] || [];
    this.userInfo = JSON.parse(localStorage.getItem('userItem')) || {};
  },

  methods: {
    // 通用的排班复选框联动逻辑
    handleSchedulingChange(form, changedField, otherField) {
      if (form[changedField] === 1) {
        form[otherField] = 0;
      } else if (form[changedField] === 0 && form[otherField] === 0) {
        this.$nextTick(() => {
          form[changedField] = 1;
          this.$message.warning('至少需要选择一个排班选项，已自动选中无需排班');
        });
      }
    },
    handleSchedulingBChange(value) {
      this.handleSchedulingChange(this.addForm, 'schedulingB', 'schedulingC');
    },
    handleSchedulingCChange(value) {
      this.handleSchedulingChange(this.addForm, 'schedulingC', 'schedulingB');
    },
    handleEditSchedulingBChange(value) {
      this.handleSchedulingChange(this.editForm, 'schedulingB', 'schedulingC');
    },
    handleEditSchedulingCChange(value) {
      this.handleSchedulingChange(this.editForm, 'schedulingC', 'schedulingB');
    },

    // 科室变更获取医生列表
    async handleDeptChange() {
      if (this.addForm.deptId) {
        try {
          const activeList = await getActiveList({ deptId: this.addForm.deptId });
          this.active = activeList.data.map(v => ({
            label: v.fullName,
            id: v.id,
            userCode: v.userCode,
            professionalTitle: v.professionalTitle
          }));
        } catch (error) {
          console.error('获取医生列表失败:', error);
          this.active = [];
        }
      }
    },

    // 时间范围变更（新增）
    handleTimeChange(val, startField, endField) {
      if (val?.length === 2) {
        this.addForm[startField] = val[0];
        this.addForm[endField] = val[1];
      }
    },
    // 时间范围变更（编辑）
    handleTimeChange2(val, startField, endField) {
      if (val?.length === 2) {
        this.editForm[startField] = val[0];
        this.editForm[endField] = val[1];
      }
    },

    // 挂号类别对话框关闭
    handleEditCategoryClose() {
      this.editCategoryForm = getEmptyEditCategoryForm();
      this.editCategoryDialogVisible1 = false;
    },
    handleAddCategoryClose() {
      this.addCategoryForm = getEmptyAddCategoryForm();
      this.selectedRow = null;
      this.addCategoryDialogVisible = false;
    },

    // 挂号类别搜索（注意：会修改原数组，保留原逻辑）
    handleSimpleSearch(query) {
      if (!query) return;
      const lowerQuery = query.toLowerCase();
      this.categoryOptions = this.categoryOptions.filter(item => {
        return (
            item.label.includes(query) ||
            (item.pycode && item.pycode.toLowerCase().includes(lowerQuery))
        );
      });
    },

    // 编辑坐诊信息
    async handleClickEdit(data) {
      this.selectedRow = null;
      this.tableData2 = [];
      try {
        const clinicSchedule = await getCategoryById({ id: data.id });
        this.tableData2 = clinicSchedule.data.registertypeDrgstRespVOS.map(item => ({
          rgstTypeId: item.id,
          mainType: item.mainType,
          odcost: Number(item.odcost).toFixed(2),
        }));
        if (data.deptId) {
          const activeList = await getActiveList({ deptId: data.deptId });
          this.active = activeList.data.map(v => ({ label: v.fullName, id: v.id }));
        }
        this.editForm = { ...data };
        this.editDialogVisible = true;
      } catch (error) {
        console.error('加载编辑数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },

    // 表格行点击高亮
    handleRowClick(row) {
      this.$refs.myTable.setCurrentRow(row);
      this.selectedRow = row;
    },

    // 添加挂号类别
    handleCategoryAdd() {
      this.addCategoryDialogVisible = true;
      this.addCategoryForm = {
        rgstTypeId: null,
        mainType: this.tableData2.some(item => item.mainType === 1) ? 0 : 1,
        odcost: null
      };
    },

    // 编辑挂号类别
    handleCategoryEdit() {
      if (!this.selectedRow) return;
      this.editCategoryForm = { ...this.selectedRow };
      this.editCategoryDialogVisible1 = true;
    },

    // 新增挂号类别数据
    handleAddPriceData() {
      if (!this.addCategoryForm.rgstTypeId) {
        this.$message.warning('请选择挂号类别');
        return;
      }
      const mainTypeOnes = this.tableData2.filter(item => item.mainType === 1);
      if (mainTypeOnes.length >= 1 && this.addCategoryForm.mainType === 1) {
        this.$message.error('只能存在一个主要类别');
        return;
      }
      const foundItem = this.categoryOptions.find(item => item.id === this.addCategoryForm.rgstTypeId);
      if (foundItem) {
        this.addCategoryForm.odcost = Number(foundItem.odcost).toFixed(2);
        this.tableData2.push({ ...this.addCategoryForm });
        this.addCategoryDialogVisible = false;
        this.addCategoryForm = getEmptyAddCategoryForm();
        this.selectedRow = null;
      }
    },

    // 编辑挂号类别数据
    async handleEditCategoryData() {
      if (!this.editCategoryForm.rgstTypeId) {
        this.$message.warning('请选择挂号类别');
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        const index = this.tableData2.findIndex(item => item.rgstTypeId === this.selectedRow?.rgstTypeId);
        if (index !== -1) {
          const foundItem = this.categoryOptions.find(item => item.id === this.editCategoryForm.rgstTypeId);
          if (foundItem) {
            this.editCategoryForm.odcost = foundItem.odcost;
            this.$set(this.tableData2, index, { ...this.editCategoryForm });
            this.editCategoryForm = getEmptyEditCategoryForm();
            this.selectedRow = null;
            this.editCategoryDialogVisible1 = false;
          }
        }
      });
    },

    // 删除挂号类别
    handlePriceDelete() {
      if (!this.selectedRow) return;
      this.tableData2 = this.tableData2.filter(item => item.rgstTypeId !== this.selectedRow.rgstTypeId);
      this.selectedRow = null;
    },

    // 提交编辑表单验证
    submitForm() {
      this.$refs.editFormRef.validate(valid => {
        if (valid) this.editCategoryData();
        else this.$message.error('请填写完整表单信息');
      });
    },

    // 新增坐诊数据
    async addCategoryData() {
      await withLoading(this, '数据提交中...')(async () => {
        if (!this.addForm.deptId || !this.addForm.doctorId) {
          this.$message.error(!this.addForm.deptId ? '科室不能为空' : '医生不能为空');
          return;
        }
        if (this.addForm.schedulingB === 0 && this.addForm.schedulingC === 0) {
          this.$message.error('请选择排班选项');
          return;
        }
        const timeError = validateScheduleTimes(this.addForm);
        if (timeError) {
          this.$message.error(timeError);
          return;
        }
        this.addForm.rgstTypes = this.tableData2;
        if (!this.addForm.rgstTypes.length) {
          this.$message.error('主挂号类别不能为空!');
          return;
        }
        const res = await addClinicSchedule(this.addForm);
        if (res.code === 200) {
          await this.loadData();
          this.addForm = getEmptyAddForm();
          this.tableData2 = [];
          this.addDialogVisible = false;
        } else {
          this.$message.error(res.message || '添加失败');
        }
      });
    },

    // 编辑坐诊数据
    async editCategoryData() {
      await withLoading(this, '数据提交中...')(async () => {
        this.editForm.rgstTypes = this.tableData2;
        if (!this.editForm.rgstTypes.length) {
          this.$message.error('请添加至少一项挂号类别');
          return;
        }
        if (this.editForm.schedulingB === 0 && this.editForm.schedulingC === 0) {
          this.$message.error('请选择排班选项');
          return;
        }
        const res = await editClinicSchedule(this.editForm);
        if (res.code === 200) {
          this.editDialogVisible = false;
          await this.loadData();
          this.editForm = getEmptyEditForm();
          this.tableData2 = [];
        } else {
          this.$message.error(res.message || '修改失败');
        }
      });
    },

    // 表格列格式化
    formatColumn(row, prop) {
      if (prop === 'rgstTypeId') {
        return this.mapToLabel(row[prop], this.categoryOptions);
      }
      return row[prop];
    },
    mapToLabel(value, options) {
      if (value == null) return '';
      const found = options.find(item => item.id == value);
      return found ? found.label : value;
    },

    // 加载数据列表
    async loadData() {
      try {
        const res = await getClinicScheduleData({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          state: this.numericValue,
          deptId: this.department,
          doctorId: this.doctor,
        });
        if (res.code === 200) {
          this.tableData = res.data.content || [];
          this.pageNum = res.data.pageNum || 1;
          this.pageSize = res.data.pageSize || 8;
          this.totalSize = res.data.totalSize || 0;
        } else {
          this.$message.error(res.message || '加载数据失败');
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },

    // 启用/禁用坐诊
    async handleStartOrDisabled(row) {
      const action = row.state === 1 ? '禁用' : '启用';
      try {
        await this.$confirm(
            `请确认是否${action}${row.deptName}下【${row.doctorName}】的挂号类型`,
            "提示",
            { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
        );
        await withLoading(this, `${action}处理中...`)(async () => {
          const res = await editState({ id: row.id, state: row.state === 1 ? 0 : 1 });
          if (res.code === 200) await this.loadData();
          else this.$message.error(res.message || "操作失败");
        });
      } catch (error) {
        if (error !== 'cancel') this.$message.warning("操作已取消");
      }
    },

    // 关闭对话框（重置所有状态）
    handleClose() {
      this.editDialogVisible = false;
      this.addDialogVisible = false;
      this.selectedRow = null;
      this.tableData2 = [];
      this.addForm = getEmptyAddForm();
      this.addCategoryForm = getEmptyAddCategoryForm();
      this.loadData();
    },

    // 双击查看详情
    async handledbRow(row) {
      this.selectedRow = null;
      this.tableData2 = [];
      this.isLookData = true;
      try {
        const clinicSchedule = await getCategoryById({ id: row.id });
        this.tableData2 = clinicSchedule.data.registertypeDrgstRespVOS.map(item => ({
          rgstTypeId: item.id,
          mainType: item.mainType,
          odcost: Number(item.odcost).toFixed(2),
        }));
        if (row.deptId) {
          const activeList = await getActiveList({ deptId: row.deptId });
          this.active = activeList.data.map(v => ({ label: v.fullName, id: v.id }));
        }
        this.editForm = { ...row };
        this.editDialogVisible = true;
      } catch (error) {
        console.error('加载查看数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },

    // 按钮点击
    handClick(i) {
      if (i === 0) {
        this.addDialogVisible = true;
        this.selectedRow = null;
        this.tableData2 = [];
      }
    },

    // 状态筛选下拉
    handleCommand(command) {
      this.numericValue = command === 'a' ? 1 : command === 'b' ? 0 : null;
      this.DropDownedName = command === 'a' ? '可用' : command === 'b' ? '禁用' : '全部';
      this.loadData();
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 表格映射（保持原样）
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      return rawValue == null ? ' ' : rawValue;
    },

    // 列宽计算
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 80;
      const padding = 30;
      const texts = [...tableData.map(item => item?.[prop] ?? ''), label];
      const maxWidth = Math.max(...texts.map(t => this.getTextWidth(String(t)) + padding));
      return Math.max(minWidth, maxWidth);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>
<style lang="less" scoped>
.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.compact-form {
  .el-row {
    margin-bottom: 12px;

    &.el-row--flex {
      flex-wrap: wrap;
    }

    .el-col {
      padding-bottom: 8px;
    }
  }

  .el-form-item {
    margin-bottom: 0;

    &__label {
      line-height: 28px;
      padding-bottom: 0;
    }

    &__content {
      line-height: 28px;

      .el-select,
      .el-input,
      .el-input-number {
        width: 100%;
      }
    }
  }

  .checkbox-row {
    .el-form-item__content {
      display: flex;
      align-items: center;

      .el-checkbox {
        margin-left: 2px;
      }
    }
  }

  .table-header {
    margin: 16px 0 8px;
    display: flex;
    align-items: center;

    .transparent-btn-group {
      margin-left: 12px;

      .el-button {
        padding: 5px 8px;
      }
    }
  }
}

.custom-select .el-select__caret {
  right: 20px !important;
}

.custom-select .el-icon-circle-close {
  right: 5px !important;
}

.time-picker-center /deep/ .el-input__prefix {
  left: 10px;
}

.time-picker-center /deep/ .el-icon-time {
  font-size: 14px !important;
  margin-top: -1px;
}

.select-label {
  font-size: 14px;
  color: #606266;
  margin-right: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.el-table :deep(.perm-highlight) {
  background-color: #000 !important;
}

.el-table :deep(.perm-highlight) > td {
  background-color: transparent !important;
}

.el-table :deep(.current-row) {
  background-color: #000 !important;
}

.transparent-btn-group {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.transparent-btn {
  background-color: transparent !important;
  border: none !important;
  color: white !important;
  padding: 6px 8px !important;
  font-size: 14px !important;
}

.transparent-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.transparent-btn:active {
  transform: scale(0.95);
}

.table-header {
  background-color: #39648f;
  color: white;
  padding: 3px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px 4px 0 0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn {
  top: 12px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-dialog__header {
  background-color: #39648f;
  padding: 8px;
}

/deep/ .el-dialog__body {
  padding: 0 20px;
  border: 1px solid #efefef;
  padding: 8px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  text-align: center;
}

.MedicenCata {
  height: 100%;
  width: 100%;

  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-b {
          margin-left: 28px;
        }

        .main-icon-c {
          display: flex;
          margin-left: 28px;
        }
      }

      .table {
        padding: 0 12px;
      }
    }
  }
}
</style>